// Faza 3 — "Fă o ofertă" pe pagina produsului. Default ASCUNS (display:none
// in Liquid); decizia de afisare se ia la FIECARE incarcare din datele live
// (GET /api/offer-status) — niciodata un flag persistent (lectia
// bug-auction-widget-hidden-forever). Reguli (decise de user 16 oct 2026):
// minim 50% din pret, raspuns in 48h, max 3 contra-oferte, dupa accept
// produsul e rezervat 48h pt cumparator.

(function () {
  const API = 'https://2hand-sync.vercel.app/api';

  function fmtRON(cents) {
    return (cents / 100).toFixed(2) + ' RON';
  }

  function hideBuyButtons(widgetEl) {
    // Produs rezervat — nimeni altcineva nu-l mai poate cumpara la pret intreg
    // (serverul refuza oricum, vezi isProductReserved in create-payment-intent).
    const root = widgetEl.closest('[data-main-product]') || document;
    root.querySelectorAll('.buy_button, [data-buy-buttons], form[action^="/cart/add"]').forEach(el => {
      el.dataset.offerHidden = '1';
      el.style.display = 'none';
    });
  }

  function initWidget(widgetEl) {
    const productId = widgetEl.dataset.productId;
    const customerId = widgetEl.dataset.customerId ? Number(widgetEl.dataset.customerId) : null;
    if (!productId) return;

    const toggleEl = widgetEl.querySelector('.offer-widget-toggle');
    const formEl = widgetEl.querySelector('.offer-widget-form');
    const amountEl = widgetEl.querySelector('.offer-widget-amount');
    const submitEl = widgetEl.querySelector('.offer-widget-submit');
    const hintEl = widgetEl.querySelector('.offer-widget-hint');
    const messageEl = widgetEl.querySelector('.offer-widget-message');

    let status = null;

    function showMessage(html, isError) {
      messageEl.innerHTML = html;
      messageEl.style.color = isError ? '#b91c1c' : '#16a34a';
    }

    async function load() {
      try {
        // Faza 4: clientul logat -> App Proxy (afla daca e vanzatorul /
        // cumparatorul rezervarii, fara id-uri publice); vizitator -> public.
        let res = customerId ? await fetch(`/apps/sistem-propriu/offer-status?product_id=${encodeURIComponent(productId)}`).catch(() => null) : null;
        if (!res || !res.ok) res = await fetch(`${API}/offer-status?product_id=${encodeURIComponent(productId)}`);
        status = await res.json();
      } catch {
        return; // retea — ramane ascuns
      }
      try {
        if (status.reservation) {
          widgetEl.style.display = 'block';
          toggleEl.style.display = 'none';
          hideBuyButtons(widgetEl);
          if (status.viewer && status.viewer.is_reservation_buyer && status.reservation.status === 'accepted') {
            showMessage('🤝 Oferta ta a fost acceptată! Produsul e rezervat pentru tine — verifică emailul pentru link-ul de plată (valabil 48h).', false);
          } else {
            showMessage(status.reservation.status === 'paid' ? 'Produs vândut.' : 'Produs rezervat — un cumpărător are o ofertă acceptată.', false);
            messageEl.style.color = '#92400e';
          }
          return;
        }
        if (!status.offerable) return;
        if (status.viewer && status.viewer.is_seller) return; // propriul produs
        widgetEl.style.display = 'block';
        hintEl.textContent = `Oferta minimă: ${fmtRON(status.min_offer_cents)} · vânzătorul răspunde în 48h`;
        amountEl.min = (status.min_offer_cents / 100).toFixed(2);
        amountEl.max = ((status.list_price_cents - 1) / 100).toFixed(2);
        amountEl.placeholder = `între ${fmtRON(status.min_offer_cents)} și ${fmtRON(status.list_price_cents - 100)}`;
      } catch (err) {
        console.error('[offer-widget] Eroare la randare:', err);
      }
    }

    toggleEl.addEventListener('click', () => {
      if (!customerId) {
        showMessage('Trebuie să fii autentificat ca să faci o ofertă.', true);
        return;
      }
      formEl.style.display = formEl.style.display === 'none' ? 'flex' : 'none';
      if (formEl.style.display === 'flex') amountEl.focus();
    });

    submitEl.addEventListener('click', async () => {
      const amountCents = Math.round(parseFloat(amountEl.value) * 100);
      if (!amountCents || amountCents <= 0) {
        showMessage('Introdu o sumă validă.', true);
        return;
      }
      if (status && amountCents < status.min_offer_cents) {
        showMessage(`Oferta minimă acceptată este ${fmtRON(status.min_offer_cents)}.`, true);
        return;
      }
      if (status && amountCents >= status.list_price_cents) {
        showMessage('Oferta trebuie să fie sub prețul afișat — altfel poți cumpăra direct.', true);
        return;
      }
      submitEl.disabled = true;
      showMessage('Se trimite oferta...', false);
      try {
        const res = await fetch('/apps/sistem-propriu/make-offer', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ product_id: Number(productId), amount_cents: amountCents }),
        });
        const data = await res.json();
        if (data.error) {
          showMessage(data.message || 'Nu am putut trimite oferta — încearcă din nou.', true);
        } else {
          formEl.style.display = 'none';
          toggleEl.style.display = 'none';
          showMessage(`Oferta de ${fmtRON(amountCents)} a fost trimisă! Vânzătorul are 48h să răspundă. Urmărește negocierea în <a href="/pages/ofertele-mele" style="text-decoration:underline">Ofertele mele</a>.`, false);
        }
      } catch {
        showMessage('Eroare de rețea — încearcă din nou.', true);
      } finally {
        submitEl.disabled = false;
      }
    });

    load();
  }

  function boot() {
    document.querySelectorAll('.offer-widget').forEach(initWidget);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
